import * as forge from 'node-forge';
import { ENVIRONMENT } from '../../../environment/environment';

export function removeWhiteSpace(value: string): string {
    if (!value || (value && value.trim() === '')) {
        return value;
    }

    return value.split(/[\s()]+/).join('');
}

/**
 * Returns `true` only when the value is an absolute HTTP(S) URL (starts with
 * `http://` or `https://`). Use it to reject scheme-less/relative values that the
 * browser would otherwise resolve against the current origin.
 */
export function isAbsoluteHttpUrl(url: string): boolean {
    return /^https?:\/\//i.test(url);
}

export function encryptString(inputValue: string): string {
    const publicKey = forge.pki.publicKeyFromPem(ENVIRONMENT.cryptoPublicKey);
    const encryptedString = publicKey.encrypt(forge.util.encodeUtf8(inputValue), 'RSAES-PKCS1-V1_5', {
        md: forge.md.sha1.create(),
    });

    return forge.util.encode64(encryptedString);
}
